import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import { HookFormInputGroup } from "components";
import {
	OTP_LENGTH,
	UserProfileFields,
	ValidationMessages,
} from "globalConstants";
import { useConfirmPhoneChangeMutation } from "queries";
import { uiActions } from "store";
import { minLength6, onlyMaxDigits6, trimNormalizer } from "validators";

import styles from "../modal.module.scss";

const { Code } = UserProfileFields;

type CodeFormProps = {
	isDisabled: boolean;
	onHide: Function;
	setMobilePhoneValue: Function;
	newMobilePhone: string;
};

const CodeForm = ({
	isDisabled,
	onHide,
	setMobilePhoneValue,
	newMobilePhone,
}: CodeFormProps) => {
	const dispatch = useDispatch();

	const formMethods = useForm({
		mode: "onChange",
		reValidateMode: "onChange",
		defaultValues: {
			[Code.name]: "",
		},
	});
	const {
		register,
		setError,
		formState: { errors },
	} = formMethods;

	const {
		mutate: confirmMobilePhoneChange,
		isLoading: isLoadingConfirmMobilePhoneChange,
	} = useConfirmPhoneChangeMutation({
		onSuccess: () => {
			onHide();
			setMobilePhoneValue(newMobilePhone);
			dispatch(
				uiActions.showSuccessNotification({
					title: `Success! Your ${newMobilePhone} has been successfully saved.`,
				}),
			);
		},
		onError: () =>
			setError(Code.name, {
				type: "focus",
				message: ValidationMessages.InvalidCode,
			}),
	});

	const onChangeCode = ({ target: { value } }) => {
		if (value.length === OTP_LENGTH) {
			confirmMobilePhoneChange({ code: value });
		}
	};

	return (
		<FormProvider {...formMethods}>
			<form>
				<div className={styles.codeInputWrap}>
					<HookFormInputGroup
						placeholder={Code.placeholder}
						name={Code.name}
						register={register}
						validator={{
							minLength6,
						}}
						colInput={12}
						errors={errors}
						normalizeOnBlur={trimNormalizer}
						normalize={onlyMaxDigits6}
						blurLoading={isLoadingConfirmMobilePhoneChange}
						onChange={onChangeCode}
						disabled={isDisabled}
					/>
				</div>
			</form>
		</FormProvider>
	);
};

export default CodeForm;
